import ReferenceConditionRenderer from "./referenceCellRenderer";

import {
  dateFormatter,
  twoDecimalFormatter,
} from "../../utils/tableDataFormatter";

export const DATA_VISUALISATION_COL_DEF = (t, defaultSettingUnit) => [
  {
    headerName: t("analysisColumn.date"),
    field: "date",
    sortable: true,
    valueFormatter: dateFormatter,
    flex: 1,
    minWidth: 150,
    headerClass: "custom-Header-cip-user-table",
  },

  {
    headerName: t("analysisColumn.permeateflowrate", {
      unit: defaultSettingUnit["flow"],
    }),
    field: "permeate_flowrate",
    sortable: true,
    valueFormatter: twoDecimalFormatter,
    flex: 1,
    minWidth: 150,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("analysisColumn.feedTemperature", {
      unit: defaultSettingUnit["temperature"],
    }),
    field: "feed_temp",
    sortable: true,
    valueFormatter: twoDecimalFormatter,
    flex: 1,
    minWidth: 150,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("analysisColumn.permeatePressure", {
      unit: defaultSettingUnit["pressure"],
    }),
    field: "permeate_pressure",
    sortable: true,
    valueFormatter: twoDecimalFormatter,
    flex: 1,
    minWidth: 150,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("analysisColumn.feedFlowrate", {
      unit: defaultSettingUnit["flow"],
    }),
    field: "feed_flowrate",
    sortable: true,
    valueFormatter: twoDecimalFormatter,
    flex: 1,
    minWidth: 150,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("analysisColumn.concentrateFlowrate", {
      unit: defaultSettingUnit["flow"],
    }),
    field: "concentrate_flowrate",
    sortable: true,
    valueFormatter: twoDecimalFormatter,
    flex: 1,
    minWidth: 150,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("analysisColumn.permeateQuality", {
      unit: defaultSettingUnit["permeate_quality"],
    }),
    field: "permeate_quality",
    sortable: true,
    valueFormatter: twoDecimalFormatter,
    flex: 1,
    minWidth: 150,
    headerClass: "custom-Header-cip-user-table",
  },

  {
    headerName: t("analysisColumn.feedPressure", {
      unit: defaultSettingUnit["pressure"],
    }),
    field: "feed_pressure",
    sortable: true,
    valueFormatter: twoDecimalFormatter,
    flex: 1,
    minWidth: 150,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("analysisColumn.concentratePressure", {
      unit: defaultSettingUnit["pressure"],
    }),
    field: "concentrate_pressure",
    sortable: true,
    valueFormatter: twoDecimalFormatter,
    flex: 1,
    minWidth: 150,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("analysisColumn.pressureDrop", {
      unit: defaultSettingUnit["pressure"],
    }),
    field: "pressure_drop",
    sortable: true,
    valueFormatter: twoDecimalFormatter,
    flex: 1,
    minWidth: 150,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("analysisColumn.feedQuality", {
      unit: defaultSettingUnit["feed_quality"],
    }),
    field: "feed_quality",
    sortable: true,
    valueFormatter: twoDecimalFormatter,
    flex: 1,
    minWidth: 150,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("analysisColumn.normalizedPermeateFlowTable", {
      unit: defaultSettingUnit["flow"],
    }),
    field: "norm_permeate_flow",
    sortable: true,
    valueFormatter: twoDecimalFormatter,
    flex: 1,
    minWidth: 250,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("analysisColumn.normalizedPressureDropTable", {
      unit: defaultSettingUnit["pressure"],
    }),
    field: "norm_pressure_drop",
    sortable: true,
    valueFormatter: twoDecimalFormatter,
    flex: 1,
    minWidth: 150,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("analysisColumn.normalizedSaltPassageTable"),
    field: "norm_salt_passage",
    sortable: true,
    valueFormatter: twoDecimalFormatter,
    flex: 1,
    minWidth: 150,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("ValueStrings.referenceCondition"),
    colId: "referenceCondition",
    cellRenderer: ReferenceConditionRenderer,
    minWidth: 220,
    flex: 1,
    lockPinned: true,
    pinned: "right",
  },
];
